﻿import {ClientEditor} from "./ClientEditor.js";
import {IDisposableLike} from "../../Tools/Disposable/IDisposableLike";
import {RessourceSlot} from "../../Tools/Disposable/RessourceSlot";
import {ClientRead} from "../../Controller/Client/ClientRead";
import {IClientModel} from "../../Model/Client/ClientModel";
import {ProfilMailEditor} from "./ProfilMailEditor.js";

export class ClientTab implements IDisposableLike {
    #clientId: string;
    #jqContainer: JQuery | undefined;
    #jqMainContainer: JQuery | undefined;
    #jqTabContainer: JQuery | undefined;
    #jqTitre: JQuery | undefined;
    #kTab: kendo.ui.TabStrip | undefined;
    #titre: string | undefined;
    #slotClientEditor = new RessourceSlot<ClientEditor>();
    #slotProfilMailEditor = new RessourceSlot<ProfilMailEditor>();

    constructor(options: IClientVleEditorOptions) {
        this.#jqMainContainer = options.jqMainContainer;
        this.#clientId = options.clientId;

    }

    public Init = async () => {
        this.#jqMainContainer.empty();
        this.#buildHtml();
        this.#buildTab();
        this.#kTab.select(0);
    }

    public get Titre(): string | undefined {
        return this.#titre;
    }

    public set Titre(value: string | undefined) {
        this.#titre = value;
        this.#jqTitre.text(this.#titre);
    }

    #buildHtml = () => {
        this.#jqContainer = $("<div></div>")
            .css({
                height: "100%",
                width: "100%",
                margin: 0, padding: 0,
                display: "flex",
                flexDirection: "column"
            })
            .appendTo(this.#jqMainContainer)

        this.#jqTitre = $("<h2>Client</h2>")
            .css({marginLeft: "10px", padding: 0})
            .appendTo(this.#jqContainer);

        this.#jqTabContainer = $("<div></div>")
            .css({display: "flex", flexGrow: "1"})
            .appendTo(this.#jqContainer);

        const ul = $("<ul></ul>")
            .appendTo(this.#jqTabContainer)

        ul.append("<li circ-action='generalite'>Généralités</li>");
        ul.append("<li circ-action='optionmail'>Paramètres Mail</li>");
        // L'ancien onglet « Comptes » (table COMPTE, auth V1 supprimée) a été
        // retiré : le compte de service du client est dans Généralités.

        this.#jqTabContainer.append("<div circ-id='generalite'></div>");
        this.#jqTabContainer.append("<div circ-id='optionmail'></div>");
    }

    #buildTab = () => {
        this.#kTab = this.#jqTabContainer.kendoTabStrip({
            animation: false,
            select: (e: kendo.ui.TabStripSelectEvent) => {
                switch ($(e.item).attr("circ-action")) {
                    case "generalite":
                        this.#loadClient().then((client: IClientModel) => {
                            this.#slotClientEditor.Reset(() => new ClientEditor({
                                jqMainContainer: this.#jqTabContainer.find("[circ-id='generalite']"),
                                clientId: this.#clientId,
                                model: client
                            })).Init().then();
                        });
                        break;
                    case "optionmail":
                        this.#slotProfilMailEditor.Reset(() => new ProfilMailEditor({
                            jqMainContainer: this.#jqTabContainer.find("[circ-id='optionmail']"),
                            clientId: this.#clientId,
                        })).Init().then();
                        break;


                }
            }
        }).data("kendoTabStrip");
    }

    #loadClient = async () => {
        return ClientRead.Read({
            AsNoTracking: true,
            PrimaryKey: this.#clientId,
        }).then(x => {
            this.Titre = x[0].RaisonSociale;
            return x[0];
        });
    }

    public Dispose = () => {
        this.#slotClientEditor.Dispose();
        this.#slotProfilMailEditor.Dispose();
        this.#kTab.destroy();
        this.#jqContainer?.remove();
        console.log("ClientTab disposed");
    }
}

export interface IClientVleEditorOptions {
    clientId: string;
    jqMainContainer: JQuery;
    titre?: string;
}
